import { DataSource, DataSourceExecutionEvent, DataSourceMode } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutAdditionalDetailsFTLUnauthenticated } from "./autogen/AutogenLayoutAdditionalDetailsFTLUnauthenticated";

export class AdditionalDetailsFTLUnauthenticated extends AutogenLayoutAdditionalDetailsFTLUnauthenticated {

    private orderId: string;

    /** This is an event handler for the afterExecution event of sourceCustomerOrderDetail.  */
    sourceCustomerOrderDetailAfterExecution(event: DataSourceExecutionEvent) {
        this.orderId = event.dataSource.activeRow?.get("orders.id");
        const row = event.dataSource.activeRow as ModelRow;
        this.tableReferenceNumbers.dataSource = new DataSource();
        this.populateDataSource(row?.get("reference_numbers"), this.tableReferenceNumbers.dataSource);
    }

    private populateDataSource(data: [], dataSource: DataSource) {
        dataSource.setRowsAndMode(DataSourceMode.NONE, data?.map(data => new ModelRow(dataSource.url, false, data)) ?? []);
    }
}
